import React from 'react';
import styled from 'styled-components';
import { useCourseMainDataQuery } from '../hooks/use-course-main-data-query';

import Accordion from 'react-bootstrap/Accordion';
import Nav from 'react-bootstrap/Nav';

const CustomAccordion = styled(Accordion)`
  .accordion-body {
    padding: 0.5rem 0.7rem;
  }

  .accordion-button {
    padding: 0.6rem 1.25rem;
    font-size: 0.938rem;
  }

  .accordion-button {
    color: #222;
  }

  .accordion-button:not(.collapsed) {
    color: #222;
    background-color: #93d8b63d;
  }

  .accordion-button:focus {
    border-color: #80d1a954;
    box-shadow: 0 0 0 0.25rem #7fd1a859;
  }

  .nav-link {
    color: #222;
    padding: 0.3rem 1rem;

    &.active {
      color: #00d268;
    }

    &:hover {
      text-decoration: none;
      color: #00d268;
    }
  }

  .accordion-button:not(.collapsed)::after {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%2300e172'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  }
`;

const CategoryAccordionMenus = ({ activeKey, currMidCate }) => {
  const courses = useCourseMainDataQuery();
  const largeCateObj = {};
  /**
   * largeCateObj = {
   *  직무: (직무경영, IT, 산업직무),
   *  경영: (직무스킬, 비즈니스스킬, IT)
   * }
   */
  courses.allCourseList33Sheet1XlsxSheet1.edges.forEach(courseEdge => {
    const largeCate = courseEdge.node.large_categories;
    let midCateSet = largeCateObj[largeCate];
    if (!midCateSet) {
      midCateSet = new Set();
      largeCateObj[largeCate] = midCateSet;
    }
    midCateSet.add(courseEdge.node.medium_categories);
  });

  const menu = Object.keys(largeCateObj).map((largeCate, i) => {
    const midCateSet = largeCateObj[largeCate];
    let midCateList = [];

    midCateList.push(
      <Nav.Link
        href={`/${largeCate}`}
        // midCate가 없고 largeCate 가 현재 largeCate와 동일하면 active
        className={!currMidCate && activeKey === largeCate && 'active'}
      >
        전체
      </Nav.Link>,
    );
    midCateSet.forEach(midCate =>
      midCateList.push(
        // largeCate와 midCate가 현재 페이지와 동일하면 active
        <Nav.Link
          href={`/${largeCate}/${midCate}`}
          className={
            (activeKey === largeCate && currMidCate === midCate) && 'active'
          }
        >
          {midCate}
        </Nav.Link>,
      ),
    );

    return (
      <>
        <Accordion.Item eventKey={largeCate}>
          <Accordion.Header>{largeCate}</Accordion.Header>
          <Accordion.Body>
            <Nav className="flex-column">{midCateList}</Nav>
          </Accordion.Body>
        </Accordion.Item>
      </>
    );
  });

  return <CustomAccordion defaultActiveKey={activeKey}>{menu}</CustomAccordion>;
};

export default CategoryAccordionMenus;
